import { get } from 'lodash/fp';
import axios from './axios';
import config from '../../helpers/config';

export default (sessionId, { designToAttach = '' }) => (
  axios.get(`${config.designBuilderApiBaseUrl}/sessions/${sessionId}`, {
    params: {
      designId: designToAttach,
    },
  })
    .then(get('data'))
);

